import { useState } from "react";
import { Link } from "react-router-dom";
import { toast } from "sonner";
import { api, apiErr } from "@/lib/api";

export default function ForgotEmail() {
  const [phone, setPhone] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);

  const submit = async (e) => {
    e.preventDefault(); setBusy(true);
    try {
      await api.post("/auth/forgot-email", { phone });
      setDone(true);
    } catch (er) { toast.error(apiErr(er)); } finally { setBusy(false); }
  };

  return (
    <div className="min-h-screen flex items-center justify-center px-4" style={{ background: "linear-gradient(135deg,#0a2f6e 0%,#0b3d91 55%,#0a2f6e 100%)" }}>
      <div className="w-full max-w-md bg-white rounded-3xl shadow-2xl p-8 animate-fade-up">
        <Link to="/" className="flex flex-col items-center gap-2 mb-5" data-testid="fe-logo">
          <img src="/rsmart-pos-logo.png" alt="Rs. Mart POS" className="w-20 h-20 object-contain drop-shadow" />
          <span className="font-extrabold text-xl tracking-tight">Rani Super Market</span>
        </Link>
        <h1 className="text-2xl font-bold text-center">Forgot Email ID?</h1>
        <p className="text-center text-slate-500 text-sm mt-1">Apna registered phone number daalein — account milne par email ID ki jaankari aapko bhej di jayegi</p>

        {done ? (
          <div className="mt-6 text-center space-y-4" data-testid="fe-result">
            <p className="text-sm text-slate-500 bg-slate-50 border border-slate-200 rounded-2xl p-5" data-testid="fe-generic-msg">
              Agar ye number registered hai, to linked email ID ki jaankari aapko bhej di jayegi. Na mile to number check karein ya store se sampark karein.
            </p>
            <Link to="/login" data-testid="fe-back-login" className="inline-block w-full py-3 bg-emerald-600 hover:bg-emerald-700 text-white rounded-xl font-bold transition-colors">Back to Login</Link>
          </div>
        ) : (
          <form onSubmit={submit} className="mt-6 space-y-3">
            <input data-testid="fe-phone" type="tel" placeholder="Registered phone number (e.g. 9955994441)" value={phone} onChange={(e) => setPhone(e.target.value)} required minLength={7} className="w-full border border-slate-200 rounded-xl px-4 py-3 text-sm" />
            <button data-testid="fe-submit" disabled={busy} className="w-full py-3 bg-emerald-600 hover:bg-emerald-700 disabled:opacity-60 text-white rounded-xl font-bold transition-colors">{busy ? "Checking…" : "Find my Email ID"}</button>
            <p className="text-center text-xs text-slate-400">Security ke liye hum registered number par hi email ki jaankari bhejte hain</p>
          </form>
        )}

        <p className="text-center text-sm text-slate-500 mt-5">
          Password bhool gaye? <Link to="/forgot-password" data-testid="fe-forgot-password" className="text-emerald-600 font-bold">Reset password</Link>
        </p>
      </div>
    </div>
  );
}
